export const getFormattedCountLabel = (
    count: number,
    { many, one, some }: { many: string; one: string; some: string },
) => {
    const fromTenToTwenty = count > 10 && count < 20;
    const remainder = count % 10;
    const suffixOv = fromTenToTwenty || (remainder >= 5 && remainder <= 9) || remainder === 0;
    const suffixNon = remainder === 1;

    if (suffixOv) {
        return many;
    } else if (suffixNon) {
        return one;
    } else {
        return some;
    }
};
